<script setup>
import ExportButton from "@/components/global-themed/buttons/ExportButton.vue";
import KitSignUpBanner from "@/components/citations/partials/KitSignUpBanner.vue";
import CitationLocations from "@/components/citations/partials/CitationLocations.vue";
import CitationAudit from "@/components/citations/partials/CitationAudit.vue";
import CitationSync from "@/components/citations/partials/CitationSync.vue";
import {selectedLocation, disableExportButton, downloadExportMutation} from "@/composables/citations/useCitations";

import {onMounted} from "vue";
import useUser from "@/composables/useUser";

const props = defineProps({
  hasKit: {
    type: Boolean,
    required: true,
  },
  locationId: {
    type: Number,
    required: true,
  },
  isGbpLocation: {
    type: Boolean,
    required: true,
  }
});

const {mutate: downloadExport, isPending} = downloadExportMutation();
const { isOrganisationAdmin } = useUser();

onMounted(() => {
  selectedLocation.value = props.locationId;
});
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-y-8">
      <div class="tw-flex tw-flex-col tw-gap-y-6">
        <div class="tw-flex tw-justify-between">
          <h1 class="tw-font-bold tw-text-4.5xl tw-text-neutral-900">
            Your Local Citations
          </h1>

          <ExportButton
            :disabled="disableExportButton || isPending"
            :loading="isPending"
            @click="downloadExport({hasKit, isGbpLocation})"
          >
            Export Audit
          </ExportButton>
        </div>

        <div
          v-if="isGbpLocation"
          class="tw-flex tw-justify-between tw-gap-16"
        >
          <CitationLocations :location-id="selectedLocation" />
          <KitSignUpBanner
            v-if="!hasKit && isOrganisationAdmin"
            :is-gbp-location="isGbpLocation"
          />
        </div>
      </div>

      <CitationSync v-if="hasKit" />
      <CitationAudit
        v-else
        :location-id="selectedLocation"
        :is-gbp-location="isGbpLocation"
      />
    </div>
  </div>
</template>
